module.exports = __webpack_public_path__ + "e2d58dacd9f0b75252ec9993f9661284.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/microsoft_2021_chart.png
// module id = 1692
// module chunks = 0